import React from 'react';

export const ServiceBadges = ({ services, small }) => {
  return (
    <div className={small && 'p-2px'}>
      {services?.map((serviceWrapper) => (
        <div
          key={serviceWrapper.service.id}
          className={`badge mr-1 ${small ? 'p-4px tx-05':''}`}
          style={{ backgroundColor: serviceWrapper.service.color }}
        >
          {serviceWrapper.service.shortName}
        </div>
      ))}
    </div>
  );
};
